import { useCallback } from 'react';
import { localized } from '@platform/core/lib/localized';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { ILocalizedText } from '@platform/core/types';

/** Хук для підписів з метаданих мовою інтерфейсу. */
export function useLabel(): (text: ILocalizedText | null | undefined) => string {
  const lang = useAppSelector(selectLang);
  return useCallback((text: ILocalizedText | null | undefined) => localized(text, lang), [lang]);
}
